import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Autocomplete from '@mui/material/Autocomplete';
import { useFormContext, Controller } from 'react-hook-form';

export default function MultipleSelectChip({
  options = [],
  name,
  label,
  formProps,
  defaultValues = [],
  sx,
  ...params
}) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const rawValue = field.value || [];
        const selectedIds = rawValue.map((item) =>
          typeof item === 'string' ? item : item?._id
        );
        const selectedValue = options.filter((opt) =>
          selectedIds.includes(opt._id)
        );

        return (
          <FormControl {...params} size="small" sx={sx}>
            <Autocomplete
              multiple
              disableCloseOnSelect
              options={options}
              value={selectedValue}
              onChange={(event, newValue) =>
                field.onChange(newValue.map((item) => item._id))
              }
              getOptionLabel={(option) => option?.name ?? ''}
              isOptionEqualToValue={(option, val) => option?._id === val?._id}
              renderTags={(selected, getTagProps) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selected.map((option, index) => (
                    <Chip
                      {...getTagProps({ index })}
                      key={option._id}
                      label={option?.name}
                    />
                  ))}
                </Box>
              )}
              renderInput={(renderParams) => (
                <TextField
                  {...renderParams}
                  label={label}
                  size="small"
                  InputLabelProps={{ shrink: true }}
                />
              )}
            />
          </FormControl>
        );
      }}
    />
  );
}
